module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_ru_russian-c789ea20a0f569d9d6a92d6d34f452a1.svg";